// ======================================================================
// FILE:
// src/modules/service_crm/components/FormSectionCard.jsx
//
// MODULE: Service CRM
// PURPOSE:
//   Reusable form section wrapper
//
// FEATURES:
//   - Collapsible support
//   - Default expanded/collapsed
//   - Reusable ERP section card
//
// USAGE:
//   <FormSectionCard
//      title="Invoice Details"
//      collapsible
//      defaultExpanded={true}
//   >
// ======================================================================

import React, { useState } from "react";

export default function FormSectionCard({
  title,
  children,

  rightContent = null,

  collapsible = false,

  defaultExpanded = true,
}) {

  // -------------------------------------------------------------------
  // EXPAND / COLLAPSE STATE
  // -------------------------------------------------------------------
  const [expanded, setExpanded] =
    useState(defaultExpanded);

  // -------------------------------------------------------------------
  // TOGGLE
  // -------------------------------------------------------------------
  function toggleExpand() {

    if (!collapsible) return;

    setExpanded((prev) => !prev);
  }

  // -------------------------------------------------------------------
  // RENDER
  // -------------------------------------------------------------------
  return (

    <div
      style={{
        background: "#fff",

        borderRadius: 14,

        marginBottom: 20,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

        overflow: "hidden",
      }}
    >

      {/* ========================================================= */}
      {/* HEADER */}
      {/* ========================================================= */}

      <div
        onClick={toggleExpand}

        style={{
          padding: "14px 18px",

          borderBottom:
            expanded
              ? "1px solid #e9ecef"
              : "none",

          background:
            "linear-gradient(90deg, #0d6efd, #3d8bfd)",

          color: "#fff",

          display: "flex",

          justifyContent:
            "space-between",

          alignItems: "center",

          cursor:
            collapsible
              ? "pointer"
              : "default",

          userSelect: "none",
        }}
      >

        {/* ===================================================== */}
        {/* LEFT SIDE */}
        {/* ===================================================== */}

        <div
          style={{
            display: "flex",

            alignItems: "center",

            gap: 10,
          }}
        >

          {/* COLLAPSE ICON */}
          {collapsible && (

            <div
              style={{
                fontSize: 14,

                transition:
                  "transform 0.2s ease",

                transform:
                  expanded
                    ? "rotate(90deg)"
                    : "rotate(0deg)",
              }}
            >
              ▶
            </div>
          )}

          {/* TITLE */}
          <div
            style={{
              fontSize: 16,

              fontWeight: 700,
            }}
          >
            {title}
          </div>

        </div>

        {/* ===================================================== */}
        {/* RIGHT CONTENT */}
        {/* ===================================================== */}

        {rightContent && (
          <div
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            {rightContent}
          </div>
        )}

      </div>

      {/* ========================================================= */}
      {/* BODY */}
      {/* ========================================================= */}

      {expanded && (

        <div
          style={{
            padding: 18,
          }}
        >
          {children}
        </div>

      )}

    </div>
  );
}